var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsvUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.625%",
    y1: "3.625%",
    x2: "95.275%",
    y2: "95.275%",
    id: "eh9jn82pca"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B6731",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M20 7h13v8H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15H7v13.333C7 29.254 7.727 30 8.625 30h22.75c.898 0 1.625-.746 1.625-1.667V15z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C42",
    d: "M20 15h13v8H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FA071",
    d: "M7 7h13v8H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.375 0H20v8h13V1.778C33 .796 32.273 0 31.375 0z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 0H20v8H7V1.778C7 .796 7.727 0 8.625 0z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.845 6H6v20h8.845C16.587 26 18 24.627 18 22.933V9.068C18 7.373 16.587 6 14.845 6z",
    fill: "#000",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.425 25H7V6h8.425C16.848 6 18 7.171 18 8.616v13.768C18 23.829 16.847 25 15.425 25z",
    fill: "#000",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.979 24H7V6h7.979C16.095 6 17 6.967 17 8.16v13.68c0 1.193-.905 2.16-2.021 2.16z",
    fill: "#000",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 24H1.7A1.7 1.7 0 0 1 0 22.3V8.7C0 7.76.76 7 1.7 7h13.6c.94 0 1.7.76 1.7 1.7v13.6c0 .94-.76 1.7-1.7 1.7z",
    fill: "url(#eh9jn82pca)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.22 11h1.866l1.515 3.003L10.2 11h1.744l-2.402 4L12 19h-1.84l-1.65-3.144L6.867 19H5l2.498-4.014z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvUploadIcon);
export default __webpack_public_path__ + "static/media/csv-upload-icon.4e9b6a7ee0f6c1a9dea87de71776078e.svg";
export { ForwardRef as ReactComponent };